import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Routes from "./Routes";
// import { useSocket } from "./hooks/socketHook";
// import { toast } from "react-toastify";
// import { GoogleMap, LoadScript, Polygon } from "@react-google-maps/api";

// import Routes from "./Routes";

const App = () => {
  const dispatch = useDispatch();

  // const navigate = useNavigate();
  const { token, user } = useSelector((state) => state.auth);
  const { allCompany } = useSelector((state) => state.company);
  const { pageCount, flatRegionPageCount } = useSelector((state) => state.map);

  // const [company, setCompany] = useState();
  // const socket = useSocket();

  const initialCalls = useCallback(() => {
    dispatch({ type: "GET_ALL_VEHICLES" });
    dispatch({ type: "GET_AIRPORTS_DB" });
    dispatch({ type: "GET_SETTINGS" });
  }, []);

  const secondInitialCall = useCallback(() => {
    if (token) {
      dispatch({
        type: "GET_ALL_COMPANY",
        payload: { token },
      });

      dispatch({
        type: "GET_USER_DETAILS_INITIAL",
        payload: {
          token,
        },
      });
    }
  }, [token]);

  console.log(user, "<user");

  useEffect(() => {
    if (token && user) {
      dispatch({
        type: "GET_COMPANY_PERMISSION",
        payload: { token, companyId: user?.company?._id },
      });
    }
  }, [user, token]);

  const thirdInitialCall = useCallback(() => {
    dispatch({ type: "GET_REGIONS", payload: { page: pageCount } });
    dispatch({
      type: "GET_FLAT_REGIONS",
      payload: { token, page: flatRegionPageCount },
    });
    dispatch({ type: "GET_TOTAL_REGIONS" });
  }, []);

  function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  useEffect(() => {
    const timer = setTimeout(async () => {
      // dispatch({ type: "GET_ALL_VEHICLES" });
      // dispatch({ type: "GET_REGIONS", payload: { page: pageCount } });
      // dispatch({
      //   type: "GET_FLAT_REGIONS",
      //   payload: { token, page: flatRegionPageCount },
      // });
      // dispatch({ type: "GET_TOTAL_REGIONS" });
      // dispatch({ type: "GET_AIRPORTS_DB" });
      // dispatch({ type: "GET_SETTINGS" });

      await timeout(4000);
      initialCalls();
      secondInitialCall();
      await timeout(1000);
      thirdInitialCall();

      // if (token) {
      //   dispatch({
      //     type: "GET_ALL_COMPANY",
      //     payload: { token },
      //   });

      //   dispatch({
      //     type: "GET_USER_DETAILS_INITIAL",
      //     payload: {
      //       token,
      //     },
      //   });
      // }
    }, 500);

    return () => clearTimeout(timer);
  }, [dispatch, token]);

  useEffect(() => {
    const email = localStorage.getItem("email");

    if (!token && email) {
      dispatch({ type: "GET_TOKEN", payload: { email } });
    }
  }, [dispatch, token]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (token) {
        dispatch({
          type: "GET_USER_DETAILS",
          payload: {
            token,
          },
        });
      }
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [token, dispatch]);

  return (
    <>
      <Routes token={token} />
    </>
  );
};

// test
export default React.memo(App);
